// extracted by mini-css-extract-plugin
module.exports = {"grid":"styles_grid__34Yu3"};